import { Stack, Typography, type TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  alignItems: "stretch",
  overflowX: "hidden",
  marginTop: theme.spacing(1.6),
  gap: theme.spacing(1.5),
  paddingBottom: 28,
}));

export const PageTitle = styled(Typography)<TypographyProps>(() => ({
  fontWeight: 700,
  fontSize: 42,
  letterSpacing: "-0.02em",
  color: "text.primary",
  marginBottom: 8,
  textAlign: "center",
}));

export const PageSubtitle = styled(Typography)<TypographyProps>(() => ({
  fontSize: 18,
  marginBottom: 32,
  textAlign: "center",
}));

export const SectionLabel = styled(Typography)<TypographyProps>(() => ({
  fontSize: 16,
  fontWeight: 700,
  letterSpacing: "0.1em",
  color: "#9CA3AF",
  textTransform: "uppercase",
  display: "block",
  marginTop: 40,
  marginBottom: 1.5,
}));
